import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as PairingConst from '../../../pairing.constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@auth0/auth0-angular';
import { PairingStepFormApi } from '../pairing-step-form/pairing-step-form.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
})
export class HomeComponent implements OnInit {
  error: string;
  errM: null;
  insightSubModuleArray: string[] = [];

  constructor(
    private readonly router: Router,
    private readonly spinnerService: NgxSpinnerService,
    private readonly auth: AuthService,
    private readonly pairingStepFormApi: PairingStepFormApi
  ) {
  }
  isInsightsAllowed: boolean = false;

  ngOnInit(): void {
    this.auth.user$.subscribe((user) => {
      sessionStorage.setItem('id', user?.sub);
      return this.pairingStepFormApi.getUser().subscribe((res: any) => {
        const modules = res.result.userSubModules;
        const moduleArray: string[] = modules.map((m: { subModuleName: string; }) => m.subModuleName);
        if (moduleArray.includes(PairingConst.INSIGHT)) {
          this.isInsightsAllowed = true;
          const insightModule = modules.find((m: { subModuleName: string; subModuleChildren?: string[] }) => 
            m.subModuleName === PairingConst.INSIGHT
          );
          sessionStorage.removeItem('insightSubModule');
          this.insightSubModuleArray = insightModule?.subModuleChildren || [];
          sessionStorage.setItem('insightSubModule', JSON.stringify(this.insightSubModuleArray));
        }

        this.error = '';
      },
        (err: any) => {
          this.spinnerService.hide();
          if (this.errM !== null || this.errM !== undefined || this.errM) {
            if (err.status == 401 || err.status == 403) {
              this.error =
                'Authentication Failed! due to some technical error, Please try to relogin.';
            } else if (err.error instanceof SyntaxError || err.status === 200) {
              // Server responded with a non-JSON body (e.g. an HTML error/login page)
              this.error =
                'Unexpected response from server. Please try again later.';
            } else if (String(err.status).startsWith('5')) {
              this.error =
                'Service unavailable due to Internal Server Error.';
            }
          }
        });
    });
  }

  onCreateNewRequest() {
    this.router.navigate(['/pairingAsProduct']);
  }

  goToInsights() {
    this.router.navigate(['/insights']);
  }
}
